import firebase from 'firebase/app'
import 'firebase/auth'

import remoteConfig from '@/lib/remote-config'
import {SIGNIN_USER, UPDATE_USER_INFORMATIONS} from '@/store/modules/user/types'

import { SNACKBAR_MESSAGE } from '../helpers/eventBus'
import { anonymous_restriction } from '@/lib/remote-config/constants'

export default {
  computed: {
    isUserLogged() {
      return this.$store.state.user.userLogged
    },
    userId() {
      return this.$store.state.user.userInformations.userId
    },
    user() {
      return this.$store.state.user.userInformations
    },
    userSubscription() {
      return this.$store.state.user.subscription
    },
    userEmail() {
      return this.user.email
    }
  },
  methods: {
    logout(callback) {
      firebase.auth().signOut()

      this.$store.dispatch('LOGOUT_USER')

      if (typeof callback === 'function') {
        callback()
      }
    },
    async login(username, password) {
      const [error] = await this.$store.dispatch(SIGNIN_USER, {
        username: username,
        password: password
      })

      if (error) {
        if (error.code) {
          this.$eventBus.$emit(SNACKBAR_MESSAGE, { message: this.$t('errors.' + error.code) })
        } else {
          this.$eventBus.$emit(SNACKBAR_MESSAGE, {
            message: this.$t('errors.custom/internal-error')
          })
        }

        throw error
      }
    },
    async updateUserInformations(updatedFields) {
      if (this.isUserLogged) {
        let updatedUserPayload = this.user

        Object.keys(updatedFields).forEach(field => {
          updatedUserPayload[field] = updatedFields[field]
        })

        return await this.$store.dispatch(UPDATE_USER_INFORMATIONS, updatedUserPayload)
      }
    },

    async updateUserPassword(oldPassword, newPassword) {
      const oldCredentials = firebase.auth.EmailAuthProvider.credential(
        this.user.email,
        oldPassword
      )

      const user = firebase.auth().currentUser

      try {
        await user.reauthenticateWithCredential(oldCredentials)
        return await firebase.auth().currentUser.updatePassword(newPassword)
      } catch (error) {
        throw error
      }
    },

    assertLogged() {
      if (!this.isUserLogged) {
        // Check if the route we want to go need to be logged no matter what (IE: useraccount/*)
        if (this.$route.path.includes('/userAccount')) {
          this.$eventBus.$emit(SNACKBAR_MESSAGE, {
            message: this.$t('errors.custom/must-be-logged')
          })
          this.$router.push({ name: 'login' })

          return false
        }

        this.$eventBus.$emit(SNACKBAR_MESSAGE, { message: this.$t('errors.custom/must-be-logged') })
        this.$router.push({ name: 'login' })

        return false
      }

      return true
    }
  }
}
